import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { prepareQuery } from '@/utils/prepareQuery';

export const viewsRoute: RouteConfig = {
  path: '',
  name: 'views',
  component: () => import(/* webpackChunkName: "Views" */ '@/views/mainRoute/view/List.vue'),
  beforeEnter: (to, from, next) => {
    store
      .dispatch('view/list', prepareQuery(to))
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.VIEW_CANNOT_LIST }));
  }
};
